












































import Vue, { defineComponent, toRefs, computed, inject, watch } from "vue";
import UiDialog from "@dpa-id-components/ui-dialog";
import "@dpa-id-components/ui-dialog/dist/UiDialog.css";
import UiInput from "@dpa-id-components/ui-input";
import "@dpa-id-components/ui-input/dist/UiInput.css";
import UiButton from "@dpa-id-components/ui-button";
import useRouter from "@dpa-connect/dpa-id-user/compositions/useRouter";
import shareSearchState from "@/composition/shareSearchState";
import store from "@/store";
import router from "@/router";
import useAuthentication from "@/composition/useAuthentication";
import maxZIndex from "@/views/lib/useMaxZIndex";

export default defineComponent({
  components: { UiDialog, UiInput, UiButton },
  setup() {
    const { validateAndRetrieveToken } = useAuthentication();
    const eventBus = inject("eventBus") as Vue;
    const { url, visible } = toRefs(shareSearchState);
    const { query } = useRouter(router)();

    const mailtoLink = computed(() => {
      const body = `Hallo, ich habe die Suche „${encodeURI(
        shareSearchState.title
      )}” in dpa-Select erstellt, die für dich interessant sein könnte: ${
        shareSearchState.url
      }`;
      return `mailto:%20?body=${body}&subject=Gespeicherte Suche „${encodeURI(
        shareSearchState.title
      )}” von dpa-Select`;
    });

    const copyLink = () => {
      const node = document.querySelector("#shared-link");
      const selection = window.getSelection();
      const range = document.createRange();
      range.selectNodeContents(node);
      selection.removeAllRanges();
      selection.addRange(range);
      document.execCommand("copy");

      eventBus.$emit("appMessage", {
        model: true,
        text: "Link kopiert"
      });
      visible.value = false;
    };

    const sharedSearchId = computed(() => query.value.sharedSearchId);
    watch(
      sharedSearchId,
      async () => {
        if (sharedSearchId.value) {
          // 1. Retrieve shared search from filters service
          const { filterRules } = await store.dispatch(
            "filters/getSharedSearch",
            {
              sharedSearchId: sharedSearchId.value,
              authJWT: validateAndRetrieveToken()
            }
          );

          // 2. Apply filter rules
          store.commit("filterRules/setFilterRules", { filterRules });

          // 3. Remove sharedSearchId query
          const newQuery = {
            ...query.value
          };
          delete newQuery.sharedSearchId;
          router.push({ query: newQuery });
        }
      },
      { immediate: true }
    );

    return {
      visible,
      url,
      mailtoLink,
      copyLink,
      maxZIndex
    };
  }
});
